module.exports = __webpack_public_path__ + "static/img/QLD-24.44985fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-24.jpg
// module id = bRKN
// module chunks = 0